import React from 'react';
import { Text, Theme } from '@amzn/storm-ui-v3';
import styled from 'styled-components';
import { getTimezone } from '@urc-ui/services/app-context';
import { useLocalizedDate } from '@urc-ui/hooks/i18n';
import { DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT, formatTimezone } from '@urc-ui/utils/date-utils';
import { StyledCellWrapper } from '@urc-ui/components/styles';

const DateTimeText = styled(Text)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.gray[500]};
`;

export function DateText(props: { timestamp: number | null }) {
  const timeZone = getTimezone();

  const [date, time] = useLocalizedDate([
    {
      value: props.timestamp,
      format: {
        ...DEFAULT_DATE_FORMAT,
        timeZone
      }
    },
    {
      value: props.timestamp,
      format: {
        ...DEFAULT_TIME_FORMAT,
        timeZone
      }
    }
  ]);
  if (!props.timestamp) {
    return (
      <StyledCellWrapper>
        <Text fontSize='small'>&#8212;</Text>
      </StyledCellWrapper>
    );
  }
  return (
    <StyledCellWrapper>
      <Text data-testid='date-text' fontSize='small'>{`${date}`}</Text>
      <DateTimeText fontSize='small'>{`${time} ${formatTimezone(props.timestamp)}`}</DateTimeText>
    </StyledCellWrapper>
  );
}
